module.exports = {
    // document title
    Title: "RX-PLANET",

    // Menu
    Menu: [
        {
            title: "产品管理平台",
            key: "pms",
            path: "/pms/index",
            disabled: false,
            url: ""
        },
        // {
        //     title: "内容管理平台",
        //     key: "cms",
        //     path: "/cms/index",
        //     disabled: false,
        //     url: ""
        // },
        {
            title: "运营管理平台",
            key: "omp",
            path: "/omp/index",
            disabled: false,
            url: ""
        },
        {
            title: "研发管理平台",
            key: "dev",
            path: "/dev/index",
            disabled: false,
            url: ""
        },
    ],
    defaultMenu: "cms",

    // Token
    tokenKey: "RX_Os_Token",
    tokenExpires: 2592000000, // 30 days

    // WXMP
    WxmpAccounts: [
        {
            value: "iruxu",
            label: "浮烟科技",
        },
    ],
};
